export const currentReadingSelection = (formValues: Record<string, any>): Set<string> => {
  const selected = new Set<string>();

  (formValues.modelsToAssign || []).forEach((model: string) => {
    if (typeof model === 'string') model.split(',').forEach(value => selected.add(value));
  });

  Object.entries(formValues).forEach(([key, vList]) => {
    if (key.startsWith('notebook-reading-') && Array.isArray(vList)) {
      vList.forEach(value => selected.add(value));
    }
  });

  return selected;
};

export const hasReadingSelectionChanged = (formValues: Record<string, any>, savedValues: string[] = []) => {
  const current = currentReadingSelection(formValues);
  if (current.size !== savedValues.length) return true;

  return savedValues.some(value => !current.has(value));
};
